// @flow
import React from "react";
import { Paragraph } from "@tvg/design-system/src/components/typography/paragraph";
import ThemeProvider from "@tvg/design-system/src/theming";
import type { Props } from "./types";
import buildColor from "../../_static/ColorPalette";
import { bell } from "../../_static/Icons/iconsDuotone";
import Icon from "../../_static/Icons";
import {
  Container,
  FooterContainer,
  MTPButton,
  MTPContainer,
  TitleDescriptionContainer
} from "./styled-components";

const PreferencesRaceAlerts = ({
  title,
  description,
  mtpRaceAlerts,
  qaLabel,
  footer
}: Props) => {
  const enabledColor = buildColor("blue_accent", "700");
  const defaultColor = buildColor("grey", "900");

  return (
    <ThemeProvider>
      <Container data-qa-label={`${qaLabel}-container`}>
        <TitleDescriptionContainer>
          <Paragraph
            qaLabel={`${qaLabel}-title`}
            fontFamily="medium"
            fontSize={16}
            color={defaultColor}
            mb={8}
          >
            {title}
          </Paragraph>
          <Paragraph
            qaLabel={`${qaLabel}-description`}
            fontFamily="regular"
            fontSize={14}
            color={buildColor("grey", "700")}
            mb={16}
          >
            {description}
          </Paragraph>
        </TitleDescriptionContainer>
        <MTPContainer>
          <MTPButton
            $isEnable={mtpRaceAlerts[0].enable}
            onClick={mtpRaceAlerts[0].onClick}
            data-qa-label={`${qaLabel}-mtp-0-button`}
          >
            <Paragraph
              qaLabel={`${qaLabel}-mtp-0-text`}
              fontFamily="medium"
              fontSize={14}
              color={mtpRaceAlerts[0].enable ? enabledColor : defaultColor}
            >
              {mtpRaceAlerts[0].name}
            </Paragraph>
          </MTPButton>
          <MTPButton
            $isEnable={mtpRaceAlerts[1].enable}
            onClick={mtpRaceAlerts[1].onClick}
            data-qa-label={`${qaLabel}-mtp-2-button`}
          >
            <Paragraph
              qaLabel={`${qaLabel}-mtp-2-text`}
              fontFamily="medium"
              fontSize={14}
              color={mtpRaceAlerts[1].enable ? enabledColor : defaultColor}
            >
              {mtpRaceAlerts[1].name}
            </Paragraph>
          </MTPButton>
          <MTPButton
            $isEnable={mtpRaceAlerts[2].enable}
            onClick={mtpRaceAlerts[2].onClick}
            data-qa-label={`${qaLabel}-mtp-5-button`}
          >
            <Paragraph
              qaLabel={`${qaLabel}-mtp-5-text`}
              fontFamily="medium"
              fontSize={14}
              color={mtpRaceAlerts[2].enable ? enabledColor : defaultColor}
            >
              {mtpRaceAlerts[2].name}
            </Paragraph>
          </MTPButton>
        </MTPContainer>
        <FooterContainer>
          <Paragraph
            qaLabel={`${qaLabel}-footer-text`}
            fontFamily="regular"
            fontSize={14}
            color={buildColor("grey", "700")}
            // TODO: put this back to capi message
          >
            {footer[0]}
            <Icon
              icon={bell}
              size={16}
              viewBoxSize={16}
              color="transparent"
              strokeColorList={[buildColor("grey", "800")]}
            />
            {footer[1]}
          </Paragraph>
        </FooterContainer>
      </Container>
    </ThemeProvider>
  );
};

export default PreferencesRaceAlerts;
